// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Wzyi","content":"styles_content__Bluow","message":"styles_message__29H4U","buttons":"styles_buttons__ATAj5"};